export const cardClick = (
  appointment,
  selectedAppointmentId,
  setSelectedAppointmentId,
  setAppointmentSelected,
  appointmentSelectedByClickOnCard
) => {
  if (selectedAppointmentId === appointment.id) {
    setSelectedAppointmentId(null);
    setAppointmentSelected(null);
  } else {
    setSelectedAppointmentId(appointment.id);
    setAppointmentSelected(appointment);
    appointmentSelectedByClickOnCard(appointment);
  }
};

export const isCardSelected = (appointment, selectedAppointmentId) => {
  return selectedAppointmentId === appointment.id;
};
